import { render, staticRenderFns } from "./RateDialog.vue?vue&type=template&id=10bf828c&"
import script from "./RateDialog.vue?vue&type=script&lang=js&"
export * from "./RateDialog.vue?vue&type=script&lang=js&"
import style0 from "./RateDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports